import React from 'react';

var Translate = {
    contextTypes: {
        d2: React.PropTypes.object.isRequired
    },

    getTranslation: function getTranslation(key) {
        return this.context.d2.i18n.getTranslation(key);
    }
};

export default Translate;


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/i18n/Translate.mixin.js
// module id = 103
// module chunks = 0